<!-- @format -->

<template>
	<pc-dialog
		v-if="dialogVisible"
		v-model="dialogVisible"
		:title="title"
		custom-fullscreen-class="ibps-dialog-70"
		:top="marginTop"
		width="40%"
		@fullscreen="handleFullscreen"
		@close="closeDialog"
	>
		<upload
			ref="upload"
			:multiple="multiple"
			:file-size="size"
			:accept="acceptRule"
			:fullscreen="fullscreen"
			:height="height"
			:init="dialogVisible"
			:limit="limit"
			:folder-alias="folderAlias"
			@callback="uploadCallback"
		/>
		<template #footer>
			<span class="dialog-footer">
				<pc-toolbar :actions="toolbars" @action-event="handleActionEvent" />
			</span>
		</template>
	</pc-dialog>
</template>

<script>
	import { fileTypes, allFileTypes, accept as acceptTypes } from './constants/fileTypes';
	import upload from './upload';
	// import online from './online';
	import { $utils } from '@/utils/publicUtils';
	import { PcToolbar } from '@/components/pc-toolbar/index';
	import { PcDialog } from '@/components';
	export default {
		components: {
			PcToolbar,
			upload,
			PcDialog,
			// online,
		},
		props: {
			value: {
				type: [String, Number, Array, Object],
			},
			multiple: {
				type: Boolean,
				default: false,
			},
			visible: {
				type: Boolean,
				default: false,
			},
			title: {
				type: String,
				default() {
					return '文件上传';
				},
			},
			marginTop: {
				type: String,
				default: '15vh',
			},
			height: {
				type: String,
				default: '240px',
			},
			fileSize: [Number, String],
			limit: {
				type: Number,
			},
			accept: {
				type: String,
				default: '',
			},
			fileExt: {
				type: Array,
				default: () => [],
			},
			options: {
				type: Object,
				default: () => {},
			},
			folderAlias: {
				type: String,
				default: '',
			},
		},
		data() {
			return {
				fullscreen: false,
				dialogVisible: this.visible,
				activeName: 'upload',
				buttonKey: 'confirm',
				onlineLoad: false,
				format: true,

				fileTypes,
				allFileTypes,
				acceptTypes,
				size: null,
				targetExt: false,
				acceptRule: '',
				uploadFileList: [],
				onlineFileList: [],
				fileList: this.multiple ? [] : {},

				toolbars: [
					{ key: 'save', type: 'primary', size: 'default' },
					{
						key: 'clear',
						label: '清空',
						size: 'default',
						hidden: () => {
							if (this.activeName === 'upload') return false;
							return true;
						},
					},
					{ key: 'cancel', size: 'default' },
				],
			};
		},
		watch: {
			visible: {
				handler() {
					this.dialogVisible = this.visible;
					this.activeName = 'upload';
					this.uploadFileList = [];
				},
				immediate: true,
			},
			accept: {
				handler(val) {
					if (val === '*' && this.fileExt.length !== 0) {
						const str = `.${this.fileExt.join(',').replace(/,/g, ',.')}`;
						this.acceptRule = str;
					} else {
						this.acceptRule = val;
					}
				},
				immediate: true,
			},
			fileSize: {
				handler(val) {
					if ($utils.isNotEmpty(val)) {
						this.size = typeof val === 'number' ? val * 1024 * 1024 : parseFloat(val) * 1024 * 1024;
					}
				},
				immediate: true,
			},
		},
		beforeUnmount() {
			this.fileTypes = null;
			this.allFileTypes = null;
			this.acceptTypes = null;
			this.uploadFileList = null;
			this.onlineFileList = null;
			this.fileList = null;
			this.toolbars = null;
		},
		methods: {
			handleFullscreen(val) {
				this.fullscreen = val;
			},
			handleActionEvent({ key }) {
				switch (key) {
					case 'save':
						this.handleConfirm();
						break;
					case 'cancel':
						this.closeDialog();
						break;
					case 'clear':
						this.handleClearFiles();
						break;
					default:
						break;
				}
			},
			handleClearFiles() {
				this.uploadFileList = [];
				this.$refs['upload'].clearFiles();
			},
			uploadCallback(data) {
				this.uploadFileList = data;
				if (this.multiple) {
					this.fileList = $utils.isNotEmpty(this.value) ? [...this.value, ...this.uploadFileList] : this.uploadFileList;
				} else {
					this.onlineFileList = [];
					this.fileList = this.uploadFileList;
				}
			},
			onlineCallback(data) {
				this.onlineFileList = data;
				if (this.multiple) {
					this.fileList = $utils.isNotEmpty(this.value) ? [...this.uploadFileList, ...data, ...this.value] : data;
				} else {
					this.uploadFileList = [];
					this.fileList = data;
				}
			},
			// 关闭当前窗口
			closeDialog() {
				this.uploadFileList = [];
				this.onlineFileList = [];
				this.$emit('close', false);
			},
			onTabClick(tab) {
				if (tab.name === 'online') {
					this.onlineLoad = !this.onlineLoad;
				}
			},
			onFormat(format) {
				this.format = format;
			},
			/**
			 * 文件类型的限制
			 */
			fileExtType() {
				const accept = this.accept;
				const acceptTypes = this.acceptTypes;
				const fileTypes = this.fileTypes;
				let type = '';
				let targetFileTypes = [];
				this.targetExt = false;
				for (const i in acceptTypes) {
					if (acceptTypes[i] === accept) {
						type = i;
						targetFileTypes = fileTypes[i];
					} else {
						if (accept === '*') {
							// 不限制
							targetFileTypes = '*';
						} else {
							// 自定义
							targetFileTypes = accept.split(',');
						}
					}
				}
				const fileList = this.multiple ? this.fileList : [this.fileList];
				if (targetFileTypes !== '*') {
					this.targetExt = fileList.every((i) => {
						// console.log(targetFileTypes, `.${i.ext}`) // 控件类型集，过滤文件得后缀
						if (type === 'compress') {
							return targetFileTypes.includes(`${i.resourceExtend}`);
						} else {
							return targetFileTypes.includes(`.${i.resourceExtend}`);
						}
					});
				} else {
					this.targetExt = true;
				}
				// console.log(fileList, this.targetExt, 'lll') // 已上传文件，过滤结果
				return this.targetExt;
			},
			handleConfirm() {
				const arr = [];
				if (!this.multiple) {
					if ($utils.isNotEmpty(this.uploadFileList)) {
						arr.push(this.uploadFileList);
						this.fileList = this.uploadFileList;
					}
					if ($utils.isNotEmpty(this.onlineFileList)) {
						arr.push(this.onlineFileList);
						this.fileList = this.onlineFileList;
					}
				}
				// console.log(this.fileList, 'fileList')
				if ($utils.isNotEmpty(arr) && arr.length > 1) {
					this.$message.closeAll();
					this.$message({
						message: '附件上传设置为单选，选择文件数量只能为1个',
						type: 'warning',
					});
					return;
				}
				if ($utils.isNotEmpty(this.limit) && this.limit < this.fileList.length) {
					this.$message.closeAll();
					this.$message({
						message: `超过设置最大上传数量限制${this.limit}张`,
						type: 'warning',
					});
					return;
				}
				if (!this.fileExtType()) {
					this.$message.closeAll();
					this.$message({
						message: '选择的附件中存在不符合规定类型的文件，请重新选择！',
						type: 'warning',
					});
					return;
				}
				if (!this.format) {
					this.$message.closeAll();
					this.$message.error('选择文件格式不允许！');
				} else {
					if ($utils.isEmpty(this.fileList)) {
						this.$message.closeAll();
						this.$message({
							message: '请上传或选择文件，或待文件上传成功后在继续操作！',
							type: 'warning',
						});
						return;
					}
					this.$emit('action-event', this.buttonKey, this.fileList);
				}
			},
		},
	};
</script>
